// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AccessibilityElement__wrapper--3x7","inline":"AccessibilityElement__inline--1Fk","focused":"AccessibilityElement__focused--AmP"};